import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);

$('.js-features').each(function (index, features) {
  const $features = $(features);
  const $featuresList = $features.find('.js-features-container');

  $featuresList.flickity({
    imagesLoaded: true,
    lazyLoad: true,
    contain: true,
    draggable: true,
    pageDots: false,
    arrowShape: 'M39.4 50L98.5 0v100L39.4 50z',
    cellAlign: 'left',
    wrapAround: true,
  });

  $features
    .find('.flickity-prev-next-button.previous')
    .addClass('features__button is-previous');
  $features
    .find('.flickity-prev-next-button.next')
    .addClass('features__button is-next');
});
